module.exports = __webpack_public_path__ + "img/制御工学3_10_1.929f112f.png";